/**
 * SecureAuth — Local Capacitor plugin for ASWebAuthenticationSession (iOS).
 *
 * Wraps Apple's ASWebAuthenticationSession to open OAuth URLs in a secure
 * in-app browser overlay. Shows a clean system prompt instead of the scary
 * raw-URL dialog from external Safari.
 *
 * iOS only. On Android use window.open('url', '_system') — no popup issue there.
 */

import { registerPlugin } from '@capacitor/core';

export interface SecureAuthPlugin {
    openSecureWindow(options: {
        authEndpoint: string;
        redirectUri: string;
    }): Promise<{ redirectedUri: string }>;

    /** Opens a URL in the external system browser (Safari) instead of an in-app overlay. */
    openExternalUrl(options: { url: string }): Promise<{ opened: boolean }>;
}

const SecureAuth = registerPlugin<SecureAuthPlugin>('SecureAuth');

export default SecureAuth;
